var map = {
	"./casino live.png": 835,
	"./casino live.svg": 836,
	"./casino.png": 837,
	"./casino.svg": 838,
	"./coupon.png": 839,
	"./coupon.svg": 840,
	"./gear.svg": 841,
	"./home.png": 842,
	"./home.svg": 843,
	"./info.svg": 442,
	"./live.png": 844,
	"./live.svg": 845,
	"./login.svg": 846,
	"./new-casino.svg": 847,
	"./new.svg": 848,
	"./oldhome.svg": 849,
	"./register.svg": 440,
	"./sport.png": 850,
	"./sport.svg": 851,
	"./virtual.png": 852,
	"./virtual.svg": 853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 439;